// Studyo Today Backend
// Package studyo.today.schools.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schools/v1/resources/access_kind.proto (package studyo.today.schools.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/schools/v1/resources/access_kind.proto.
 */
export const file_studyo_today_schools_v1_resources_access_kind = /*@__PURE__*/
  fileDesc("CjNzdHVkeW8vdG9kYXkvc2Nob29scy92MS9yZXNvdXJjZXMvYWNjZXNzX2tpbmQucHJvdG8SIXN0dWR5by50b2RheS5zY2hvb2xzLnYxLnJlc291cmNlcypgCgpBY2Nlc3NLaW5kEhsKF0FDQ0VTU19LSU5EX1VOU1BFQ0lGSUVEEAASGwoXQUNDRVNTX0tJTkRfRlVMTF9BQ0NFU1MQARIYChRBQ0NFU1NfS0lORF9PQlNFUlZFUhACQimqAiZTdHVkeW8uVG9kYXkuU2Nob29scy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z");

/**
 * Describes the enum studyo.today.schools.v1.resources.AccessKind.
 */
export const AccessKindSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_schools_v1_resources_access_kind, 0);

/**
 * All possible access rights which can be assigned to a school.
 *
 * @generated from enum studyo.today.schools.v1.resources.AccessKind
 */
export const AccessKind = /*@__PURE__*/
  tsEnum(AccessKindSchema);

